// extracted by mini-css-extract-plugin
export default {"wrapper":"SocialLove_wrapper__3amIo","clicked":"SocialLove_clicked__7m0tY","isFree":"SocialLove_isFree__fKi0V"};